import { StorageKeys } from "@utils/enums";
import { isDefined } from "@utils/helpers";
import { SafeLocalStorage } from "@utils/localStorage";

import { WindowKeys, WindowManagement } from "./windowManagement";

export default class SearchService {
    static setCutoff(cutoff: number): void {
        if (!isDefined(cutoff)) return;

        SafeLocalStorage.setItem(
            StorageKeys.AlgoliaDynamicFacetNamesCutoff,
            cutoff.toString(),
        );
    }

    static setAmount(amount: number): void {
        if (!amount) return;

        SafeLocalStorage.setItem(
            StorageKeys.AlgoliaDynamicFacetNamesAmount,
            amount.toString(),
        );
    }

    static resetParams() {
        SafeLocalStorage.removeItem(StorageKeys.AlgoliaDynamicFacetNamesAmount);
        SafeLocalStorage.removeItem(StorageKeys.AlgoliaDynamicFacetNamesCutoff);
    }
}

const init = () => {
    WindowManagement.saveObject(WindowKeys.SEARCH, SearchService);
};

export { init };
